var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cash-register-closed view"},[_c('div',{ref:"animationContainer",staticClass:"cash-register-closed_animation animation-container"}),_c('p',[_vm._v("The cash register is closed.")])])}
var staticRenderFns = []

export { render, staticRenderFns }